import React, { useEffect, useRef, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import {
  AddHSNCheckWarningPayloadType,
  AddStockItemPayloadType,
  ByProductDataType,
  CheckUniqueSkuNumberPayloadType,
  CoProductDataType,
  GetHSNCheckPayloadType,
  ScrapProductDataType,
  StockUploadFilePayloadType,
  UpdateStockItemListPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import {
  MulitpleFileUploadData,
  SelectOptionType,
  StockItemDetailsType,
} from "../../../../redux/clientSettings/clientSettingTypes";
import {
  returnInputFieldLength,
} from "../../../../utils/commonFunctions";
import { ConfirmationModal, DropDown, RadioContainer, RollingLoader } from "../../../commons";
import GstDetails from "./GstDetails";
import TaxDetails from "./TaxDetails";
import VatDetails from "./VatDetails";
import { RedDeleteIcon } from "../../../../assets/images";
import { PaperClipIcon } from "../../../Icon";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {  addHsnCheckWarningAction, getHsnCheckAction, multipleUploadFilesAction, resetMultipleFileUploadData, resetMultipleFileUploadError, resetMultipleFileUploadFetching, resetMultipleFileUploadSuccess } from "../../../../redux/clientSettings";
import MultiUploadWithApi from "../../../commons/UploadFileWithApi/MultiUploadWithApi";
import { GetGenerateSasTokenPayloadType } from "../../../../commonTypes/stcoToolsType";
import { getTokenGenerateForDownloadAction, resetSasTokenForDownloadFile } from "../../../../redux/stcoTools";
import MultiFilePreviewModal from "../../../commons/MultiPreviewWithApi/MultiFilePreviewModal";
import { handleHsnSacCheckForStock, handleHsnValidation } from "../../../../utils/invoiceGeneration/commonFunctions";

type RadioTypes = {
  id: string;
  name: string;
};
export type HSNWarningType={
  hsnWarning:string
}

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "not_applicable",
    name: "Not Applicable",
  },
  {
    id: "applicable",
    name: "Applicable",
  },
];

let tempByProductData = {
  byProductSingleData: {
    value: "",
    label: "Select By-Product...",
  },
  byProductPercent: "",
};

let tempCoProductData = {
  coProductSingleData: {
    value: "",
    label: "Select Co-Product...",
  },
  coProductPercent: "",
};

let tempScrapProductData = {
  scrapSingleData: {
    value: "",
    label: "Select Scrap...",
  },
  scrapProductPercent: "",
};

type AppProps = {
  history: any;
  token: string | null;
  uniqueSkuFetching?: boolean;
  skuMessage?: string | null;
  client_code: number | undefined;
  allUnitsMeasurement?: any;
  groupStockList?: any;
  // editData?: any;
  allStockItemList: any;
  singleStockItemData: StockItemDetailsType[];
  handleSubmitStockItemData?: (data: AddStockItemPayloadType) => void;
  handleUpdateStockItemData?: (data: UpdateStockItemListPayloadType) => void;
  uniqueSkuNumberCheck?: (data: CheckUniqueSkuNumberPayloadType) => void;
  searchData?: string;
  // company_name?: string;
  dispatchUploadFilesAction:(data:StockUploadFilePayloadType)=>void;
  stockFileUploadData:MulitpleFileUploadData[]|[];
  dispatchResetStockFileUploadFetching:()=>void;
  dispatchResetStockFileUploadData:()=>void;
  stockFileUploadFetching:boolean;
  success:number|null;
  dispatchResetStockFileUploadSuccess:()=>void;
  dispatchResetStockFileUploadError:()=>void;
  error:string|null
  dispatchGetTokenGenerateForDownloadAction:(data:GetGenerateSasTokenPayloadType)=>void;
  dispatchResetSasTokenForDownloadFile:()=>void;
  sasTokenForDownloadFile:string;
  dispatchGetHsnCheckAction:(data:GetHSNCheckPayloadType)=>void;
  clientMappedHSNData:any;
  dispatchAddHsnCheckWarningAction:(data:AddHSNCheckWarningPayloadType)=>void;
};

const StockItemsFrom = ({
  history,
  token,
  client_code,
  allUnitsMeasurement,
  groupStockList,
  handleSubmitStockItemData,
  handleUpdateStockItemData,
  // editData,
  uniqueSkuNumberCheck,
  skuMessage,
  uniqueSkuFetching,
  allStockItemList,
  singleStockItemData,
  searchData,
  // company_name,
  dispatchUploadFilesAction,
  stockFileUploadData,
  dispatchResetStockFileUploadFetching,
  dispatchResetStockFileUploadData,
  stockFileUploadFetching,
  dispatchResetStockFileUploadSuccess,
  dispatchResetStockFileUploadError,
  success,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  sasTokenForDownloadFile,
  dispatchGetHsnCheckAction,
  clientMappedHSNData,
  dispatchAddHsnCheckWarningAction

}: AppProps) => {
    const [showHsnWarningConfirmModal, setShowHsnWarningConfirmModal] =
      useState<boolean>(false);
  const [stockItemUnits, setStockItemUnits] = useState<SelectOptionType>({
    value: "",
    label: "Select Stock Units Measurement...",
  });
  const [groupName, setGroupName] = useState<SelectOptionType>({
    value: "",
    label: "Select Stock Group Name...",
  });
  const [finalStockItemOptions, setFinalStockItemOptions] = useState<
    SelectOptionType[] | []
  >([]);
  const [byProduct, setByProduct] = useState<ByProductDataType[]>([
    { ...tempByProductData },
  ]);
  const [coProduct, setCoProduct] = useState<CoProductDataType[]>([
    { ...tempCoProductData },
  ]);
  const [scrapProduct, setScrapProduct] = useState<ScrapProductDataType[]>([
    { ...tempScrapProductData },
  ]);
  const [finalStockItemDetailsOptions, setFinalStockItemDetailsOptions] =
    useState<SelectOptionType[] | []>([]);
  const [skuApiMessage, setSkuApiMessage] = useState<string>("");
  const [radioValue, setRadioValue] = useState("not_applicable");
  const [vatRadioValue, setVatRadioValue] = useState("not_applicable");
  const [taxRadioValue, setTaxRadioValue] = useState("nil_Rated");
  const [vatTaxRadioValue, setVatTaxRadioValue] = useState("taxable");
  const [isEdit, setIsEdit] = useState(false);
  const [formError, setFormError] = useState<any>({
    skuError: "",
    stockNameError: "",
    groupNameError: "",
    unitsError: "",
    hsnError: "",
    igstError: "",
    cessError: "",
    gstError: "",
    taxRateError: "",
    isUniqueError: false,
    maximumError: ""
  });
  const [hsnWarning , setHsnWarning] = useState<HSNWarningType>({
    hsnWarning:""
  })
  const [inputDetails, setInputDetails] = useState<any>({
    sku: "",
    stockItemName: "",
    hsnSacNo: "",
    hsnSacDetails: "",
    gst: "",
    cess: "",
    taxability: "",
    vatTaxRate: "",
    vatTaxType: "",
    rate: "",
    minimum: "",
    maximum: "",
  });

  const [allFileData, setAllFileData] = useState<any>("");

  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
  const [fileUpload, setFileUpload ] = useState([])
  const [showUploadLogoModal, setShowUploadLogoModal] =
  useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [flag, setFlag] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(false);
  const company_name = history?.location?.state?.company_name
  useEffect(()=>{
    dispatchResetStockFileUploadFetching();
    dispatchResetStockFileUploadData();
    dispatchResetStockFileUploadSuccess();
    dispatchResetStockFileUploadError();
    setAllFileData([])
    if (token) {
      let mappedFinalData = {
        token,
        clientCode: client_code,
      };
      dispatchGetHsnCheckAction(mappedFinalData);
    }
    
    
  },[])

  // FOR HANDLING MIN MAX ERROR
  useEffect(() => {
    if (inputDetails?.minimum  && parseInt(inputDetails?.minimum) > parseInt(inputDetails?.maximum)) {
      setFlag(true)
      setFormError((prev: any) => ({
        ...prev,
        maximumError: "Maximum quantity should be greater than minimum quantity!"
      }))
      setDisable(true)
    }
    else if(parseFloat(inputDetails?.minimum) > parseFloat(inputDetails?.maximum))
    {
      setFlag(true)
      setFormError((prev: any) => ({
        ...prev,
        maximumError: "Maximum quantity should be greater than minimum quantity!"
      }))
      setDisable(true)
    }
    else if(inputDetails?.minimum  != "" && inputDetails?.maximum == "")
      {
        setFlag(false);
        setDisable(true);
      }
    else if((inputDetails?.minimum == "" && inputDetails?.maximum == "")){
      setDisable(false)
    }
    else{
      setDisable(false)
    }
  }, [inputDetails?.maximum, inputDetails?.minimum])

 

  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  useEffect(() => {
    if (singleStockItemData?.length) {
      let byProduct = singleStockItemData[0]?.by_product?.map((item:any) => ({
        byProductSingleData: {
          label: item?.stock_item_name,
          value: !!item?.stock_item_id
            ? item?.stock_item_id?.toString()
            : undefined,
        },
        byProductPercent: !!item?.stock_item_percentage
          ? item?.stock_item_percentage?.toString()
          : null,
      }));

      let coProduct = singleStockItemData[0]?.co_product?.map((item:any) => ({
        coProductSingleData: {
          label: item?.stock_item_name,
          value: !!item?.stock_item_id
            ? item?.stock_item_id?.toString()
            : undefined,
        },
        coProductPercent: !!item?.stock_item_percentage
          ? item?.stock_item_percentage?.toString()
          : null,
      }));

      let scrapProduct = singleStockItemData[0]?.scrap?.map((item:any) => ({
        scrapSingleData: {
          label: item?.stock_item_name,
          value: !!item?.stock_item_id
            ? item?.stock_item_id?.toString()
            : undefined,
        },
        scrapProductPercent: !!item?.stock_item_percentage
          ? item?.stock_item_percentage?.toString()
          : null,
      }));
      setInputDetails((prev: any) => ({
        ...prev,
        sku: singleStockItemData[0]?.SKU?.toString(),
        stockItemName: singleStockItemData[0]?.stock_item_name,
        hsnSacNo:
          singleStockItemData[0]?.GST_details?.HSN_SAC_details?.HSN_SAC_no,
        hsnSacDetails:
          singleStockItemData[0]?.GST_details?.HSN_SAC_details?.HSN_SAC_details,
        taxability:
          singleStockItemData[0]?.GST_details?.tax_details?.taxability,
        gst: singleStockItemData[0]?.GST_details?.tax_details?.GST,
        cess: singleStockItemData[0]?.GST_details?.tax_details?.Cess,
        vatTaxRate: singleStockItemData[0]?.VAT_details?.tax_rate,
        vatTaxType: singleStockItemData[0]?.VAT_details?.tax_type,
        rate: singleStockItemData[0]?.rate ? singleStockItemData[0]?.rate : "",
        minimum: singleStockItemData[0]?.min_quantity ? singleStockItemData[0]?.min_quantity : null,
        maximum: singleStockItemData[0]?.max_quantity
        ? singleStockItemData[0]?.max_quantity
        : null,
 
      }));
        handleHsnSacCheckForStock( !!singleStockItemData[0]?.GST_details?.HSN_SAC_details?.HSN_SAC_no?singleStockItemData[0]?.GST_details?.HSN_SAC_details?.HSN_SAC_no:"", clientMappedHSNData, setHsnWarning, setFormError)

      
      setStockItemUnits({
        value: singleStockItemData[0]?.stock_unit_id?.toString(),
        label: `${singleStockItemData[0].stock_unit_name}(${singleStockItemData[0].stock_unit_symbol})`,
      });
      setGroupName({
        value: singleStockItemData[0]?.stock_group_id?.toString(),
        label: singleStockItemData[0]?.stock_group_name,
      });

      if (byProduct?.length > 0) {
        setByProduct([...byProduct]);
      }
      if (coProduct?.length > 0) {
        setCoProduct([...coProduct]);
      }
      if (scrapProduct?.length) {
        setScrapProduct([...scrapProduct]);
      }
      if (singleStockItemData[0].GST_applicable) {
        setRadioValue("applicable");

      }
      if (singleStockItemData[0]?.VAT_applicable) {
        setVatRadioValue("applicable");
      }

      if (
        singleStockItemData[0]?.GST_details?.tax_details?.taxability ==
        "Taxable"
      ) {
        setTaxRadioValue("taxable");
      }
      if (singleStockItemData[0]?.VAT_details?.tax_type === "Exempt") {
        setVatTaxRadioValue("exempted");
      }
      if (singleStockItemData[0]?.uploads && singleStockItemData[0]?.uploads?.length > 0) {
        setAllFileData([...singleStockItemData[0]?.uploads]);
      }
      setIsEdit(true);
    }
  }, [singleStockItemData]);
  useEffect(() => {
    let data = [
      ...byProduct?.map((el: any) =>
        el?.byProductSingleData?.value?.toString()
      ),
      ...coProduct?.map((el: any) =>
        el?.coProductSingleData?.value?.toString()
      ),
      ...scrapProduct?.map((el: any) => el?.scrapSingleData?.value?.toString()),
    ];
    if (data?.length > 0) {
      let filterData = finalStockItemOptions?.filter((item: any) => {
        return !data?.includes(item?.value?.toString());
      });

      setFinalStockItemDetailsOptions([...filterData]);
    } else {
      setFinalStockItemDetailsOptions([...finalStockItemOptions]);
    }
  }, [finalStockItemOptions, byProduct, coProduct, scrapProduct]);

  //checking Unique SKU Number
  useEffect(() => {
    if (skuMessage?.length) {
      setSkuApiMessage(skuMessage);
    }

    if (skuMessage?.length && skuMessage?.includes("not")) {
      setFormError((prev: any) => ({
        ...prev,
        isUniqueError: true,
      }));
    } else if (skuMessage?.length && !skuMessage?.includes("not")) {
      setFormError((prev: any) => ({
        ...prev,
        isUniqueError: false,
      }));
    }
  }, [skuMessage]);

  let options: any = allUnitsMeasurement?.map((e: any) => {
    return {
      value: e.stock_unit_id,
      label: `${e.stock_unit_name}(${e.stock_unit_symbol})`,
    };
  });

  let finalOptions: any = groupStockList?.map((e: any) => {
    return {
      value: e.stock_group_id,
      label: e.stock_group_name,
      count: e.count,
    };
  });

  useEffect(() => {
    let newStockItemOptions = allStockItemList?.map((item: any) => {
      return {
        value: item.stock_item_id,
        label: item.stock_item_name,
      };
    });
    setFinalStockItemOptions([...newStockItemOptions]);
  }, [allStockItemList]);

  const handleAddMoreRow = (type: string) => {
    let tempByProduct = JSON.parse(JSON.stringify(byProduct));
    let tempCoProduct = JSON.parse(JSON.stringify(coProduct));
    let tempScrapProduct = JSON.parse(JSON.stringify(scrapProduct));

    if (type === "byProduct") {
      tempByProduct?.push(tempByProductData);
      setByProduct([...tempByProduct]);
    }
    if (type === "coProduct") {
      tempCoProduct?.push(tempCoProductData);
      setCoProduct([...tempCoProduct]);
    }
    if (type === "scrapProduct") {
      tempScrapProduct?.push(tempScrapProductData);
      setScrapProduct([...tempScrapProduct]);
    }
  };

  const handleDeleteRow = (type: string, index: number) => {
    if (type === "byProduct") {
      let deletedByProduct = byProduct?.filter(
        (_: any, byIndex: number) => byIndex != index
      );
      setByProduct([...deletedByProduct]);
    }
    if (type === "coProduct") {
      let deletedCoProduct = coProduct?.filter(
        (_: any, coIndex: number) => coIndex != index
      );
      setCoProduct([...deletedCoProduct]);
    }
    if (type === "scrapProduct") {
      let deletedScrapProduct = scrapProduct?.filter(
        (_: any, scrapIndex: number) => scrapIndex != index
      );
      setScrapProduct([...deletedScrapProduct]);
    }
  };

  const handleSetRadioValue = (value: string) => {
    setRadioValue(value);
  };
  const handleSetVatRadioValue = (value: string) => {
    setVatRadioValue(value);
  };

  const handleUnitOfMeasurementData = (mode: any) => {
    setStockItemUnits({
      value: mode?.value,
      label: mode?.label,
    });
    if (mode?.value.length !== 0) {
      setFormError((prev: any) => ({
        ...prev,
        unitsError: "",
      }));
    } else {
      setFormError((prev: any) => ({
        ...prev,
        unitsError: "Please choose the Unit",
      }));
    }
  };
  const handleGroupNameData = (mode: any) => {
    setGroupName({
      value: mode?.value,
      label: mode?.label,
    });
    if (mode?.value) {
      setFormError((prev: any) => ({
        ...prev,
        groupNameError: "",
      }));
    }
  };

  const handleRateChange = (e: any) => {
    setInputDetails((prev: any) => ({
      ...prev,
      rate: e.target.value,
    }));
  };
  
  const handleMinMaxChange = (e: any) => {
    const {value, name} = e.target;
    if(e.target.value >= 0){
      setInputDetails((prev : any) => {
        if(name == 'minimum' && value == ""){
          return{
            ...prev,
            minimum: '',
            maximum: '',
          }
        }
        return{
          ...prev,
        [name]: value
        }
        
      });
      setFormError((prev: any) => ({
        ...prev,
        maximumError: ""
      }));
    }
    setFlag(false)
  }

  
  const showAsterisk = inputDetails?.minimum || inputDetails?.maximum;
  const handleStockItemData = (
    value: SelectOptionType,
    type: string,
    index: number
  ) => {
    let tempByProduct = JSON.parse(JSON.stringify(byProduct));
    let tempCoProduct = JSON.parse(JSON.stringify(coProduct));
    let tempScrapProduct = JSON.parse(JSON.stringify(scrapProduct));
    if (type === "byProduct") {
      tempByProduct?.map((item: any, byIndex: number) => {
        if (byIndex === index) {
          item.byProductSingleData = value;
        }
      });
      setByProduct([...tempByProduct]);
    }
    if (type === "coProduct") {
      tempCoProduct?.map((item: any, coIndex: number) => {
        if (coIndex === index) {
          item.coProductSingleData = value;
        }
      });
      setCoProduct([...tempCoProduct]);
    }
    if (type === "scrapProduct") {
      tempScrapProduct?.map((item: any, scrapIndex: number) => {
        if (scrapIndex === index) {
          item.scrapSingleData = value;
        }
      });
      setScrapProduct([...tempScrapProduct]);
    }
  };

  useDebounce(
    () => {
      if (inputDetails.sku) {
        if (token && client_code) {
          let finalData = {
            token,
            client_code,
            sku: Number(inputDetails.sku),
          };
          uniqueSkuNumberCheck?.(finalData);
        }
      }
    },
    500,
    [inputDetails.sku]
  );

  const Option = (props: OptionProps<any, false>) => {
    return (
      <components.Option {...props}>
        <ul className={`ledger-list`}>
          <li
            style={{
              paddingLeft: `${
                props?.data?.count !== undefined ? props?.data?.count * 10 : "0"
              }px`,
            }}
          >
            <span
              className={
                props?.data?.count === undefined
                  ? ""
                  : "stock-nested-list no-show"
              }
            >
              {props?.children}
            </span>
          </li>
        </ul>
      </components.Option>
    );
  };

  const handleStockItemDetailsChange = (e: any) => {
    const Name = e?.target.name;
    const Value = e?.target.value;
    if (Name === "sku") {
      if (Value >= 0) {
        setInputDetails((prev: any) => ({
          ...prev,
          sku: Value,
        }));
        setFormError((prev: any) => ({
          ...prev,
          skuError: "",
        }));
      }
    } else if (Name === "stockName") {
      setInputDetails((prev: any) => ({
        ...prev,
        stockItemName: Value,
      }));
      if (Value) {
        setFormError((prev: any) => ({
          ...prev,
          stockNameError: "",
        }));
      }
    }
  };


  const handleStockItemInputChange = (e: any, index: number) => {
    let name = e?.target?.name;
    let value = e?.target?.value;
    let tempByProduct = JSON.parse(JSON.stringify(byProduct));
    let tempCoProduct = JSON.parse(JSON.stringify(coProduct));
    let tempScrapProduct = JSON.parse(JSON.stringify(scrapProduct));
    if (name === "byProductPercent") {
      tempByProduct?.map((item: any, byIndex: number) => {
        if (byIndex === index) {
          item.byProductPercent = value;
        }
      });
      setByProduct([...tempByProduct]);
    }
    if (name === "coProductPercent") {
      tempCoProduct?.map((item: any, coIndex: number) => {
        if (coIndex === index) {
          item.coProductPercent = value;
        }
      });
      setCoProduct([...tempCoProduct]);
    }
    if (name === "scrapProductPercent") {
      tempScrapProduct?.map((item: any, scrapIndex: number) => {
        if (scrapIndex === index) {
          item.scrapProductPercent = value;
        }
      });
      setScrapProduct([...tempScrapProduct]);
    }
  };
  const handleCheckHsnWarning =()=>{

  if (clientMappedHSNData?.is_hsn_sac_code_check_active === 1 && hsnWarning?.hsnWarning !== "") {
    setShowHsnWarningConfirmModal(true);
    return; 
   }
  handleSubmitForm()
  }
  const handleSubmitForm = () => {
    let newCoProduct = coProduct?.map((item: CoProductDataType) => {
      return {
        stock_item_id: item?.coProductSingleData?.value
          ? item?.coProductSingleData?.value
          : null,
        stock_item_percentage: item?.coProductPercent
          ? item?.coProductPercent
          : null,
      };
    });
    let newByProduct = byProduct?.map((item: ByProductDataType) => {
      return {
        stock_item_id: item?.byProductSingleData?.value
          ? item?.byProductSingleData?.value
          : null,
        stock_item_percentage: item?.byProductPercent
          ? item?.byProductPercent
          : null,
      };
    });
    let newScrapProduct = scrapProduct?.map((item: ScrapProductDataType) => {
      return {
        stock_item_id: item?.scrapSingleData?.value
          ? item?.scrapSingleData?.value
          : null,
        stock_item_percentage: item?.scrapProductPercent
          ? item?.scrapProductPercent
          : null,
      };
    });
    if (
      (skuApiMessage?.includes("not") ||
        singleStockItemData[0]?.SKU.toString() === inputDetails?.sku) &&
      inputDetails?.sku !== "0" &&
      inputDetails?.sku &&
      inputDetails?.stockItemName.trim().length > 0 &&
      groupName.value &&
      stockItemUnits.value
    ) {
      if (
        radioValue === "not_applicable" &&
        vatRadioValue === "not_applicable"
      ) {
        if (isEdit) {
          let finalData = {
            token,
            client_code,
            sku: inputDetails?.sku,
            stockGroupId: groupName?.value,
            stockItemName: inputDetails?.stockItemName.trim(),
            stockUnitId: stockItemUnits?.value,
            gstApplicable: 0,
            vatApplicable: 0,
            stockItemId: singleStockItemData[0]?.stock_item_id?.toString(),
            byProduct: newByProduct,
            coProduct: newCoProduct,
            scrap: newScrapProduct,
            rate: inputDetails?.rate ? inputDetails?.rate : null,
            uploads:allFileData,
            maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
            minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,
          };
          handleUpdateStockItemData?.(finalData);
        } else {
          let finalData = {
            token,
            client_code,
            sku: inputDetails?.sku,
            stockGroupId: groupName?.value,
            stockItemName: inputDetails?.stockItemName.trim(),
            stockUnitId: stockItemUnits?.value,
            gstApplicable: 0,
            vatApplicable: 0,
            byProduct: newByProduct,
            coProduct: newCoProduct,
            scrap: newScrapProduct,
            rate: inputDetails?.rate ? inputDetails?.rate : null,
            uploads:allFileData,
            maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
            minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,
          };
          handleSubmitStockItemData?.(finalData);
        }
      } else if (
        radioValue === "applicable" &&
        vatRadioValue === "applicable"
      ) {
        if (
          inputDetails?.hsnSacNo &&
          inputDetails?.hsnSacNo !== "0" &&
          (inputDetails?.vatTaxRate || inputDetails?.vatTaxRate === 0)
        ) {
          if (
            inputDetails?.vatTaxRate === 0 &&
            vatTaxRadioValue === "exempted"
          ) {
            if (taxRadioValue !== "taxable") {
              if (isEdit) {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  stockItemId:
                    singleStockItemData[0]?.stock_item_id?.toString(),
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

                };
                handleUpdateStockItemData?.(finalData);
              } else {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum)  ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

                };
                handleSubmitStockItemData?.(finalData);
              }
            } else if (
              taxRadioValue == "taxable" &&
              inputDetails?.gst !== "0" &&
              inputDetails?.gst
            ) {
              if (isEdit) {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  taxability: inputDetails?.taxability,
                  gst: inputDetails?.gst,
                  cess: inputDetails?.cess,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  stockItemId:
                    singleStockItemData[0]?.stock_item_id?.toString(),
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

                };
                handleUpdateStockItemData?.(finalData);
              } else {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  taxability: inputDetails?.taxability,
                  gst: inputDetails?.gst,
                  cess: inputDetails?.cess,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

                };
                handleSubmitStockItemData?.(finalData);
              }
            } else {
              setFormError((prev: any) => ({
                ...prev,
                ...(inputDetails?.gst === "0" && {
                  gstError: "GST number can not be zero!",
                }),
                ...(!inputDetails?.gst && {
                  gstError: "GST number required",
                }),
              }));
            }
          } else if (
            inputDetails?.vatTaxRate > 0 &&
            vatTaxRadioValue !== "exempted"
          ) {
            if (taxRadioValue !== "taxable") {
              if (isEdit) {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  stockItemId:
                    singleStockItemData[0]?.stock_item_id?.toString(),
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

                };
                handleUpdateStockItemData?.(finalData);
              } else {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

                };
                handleSubmitStockItemData?.(finalData);
              }
            } else if (
              taxRadioValue == "taxable" &&
              inputDetails?.gst !== "0" &&
              inputDetails?.gst
            ) {
              if (isEdit) {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  taxability: inputDetails?.taxability,
                  gst: inputDetails?.gst,
                  cess: inputDetails?.cess,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  stockItemId:
                    singleStockItemData[0]?.stock_item_id?.toString(),
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


                };
                handleUpdateStockItemData?.(finalData);
              } else {
                let finalData = {
                  token,
                  client_code,
                  sku: inputDetails?.sku,
                  stockGroupId: groupName?.value,
                  stockItemName: inputDetails?.stockItemName.trim(),
                  stockUnitId: stockItemUnits?.value,
                  gstApplicable: 1,
                  hsnSacNo: inputDetails?.hsnSacNo,
                  hsnSacDetails: inputDetails?.hsnSacDetails,
                  taxability: inputDetails?.taxability,
                  gst: inputDetails?.gst,
                  cess: inputDetails?.cess,
                  vatApplicable: 1,
                  vatTaxType: inputDetails?.vatTaxType,
                  vatTaxRate:
                    inputDetails?.vatTaxRate == 0
                      ? "0"
                      : inputDetails?.vatTaxRate,
                  byProduct: newByProduct,
                  coProduct: newCoProduct,
                  scrap: newScrapProduct,
                  rate: inputDetails?.rate ? inputDetails?.rate : null,
                  uploads:allFileData,
                  maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                  minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


                };
                handleSubmitStockItemData?.(finalData);
              }
            } else {
              setFormError((prev: any) => ({
                ...prev,
                ...(inputDetails?.gst === "0" && {
                  gstError: "GST number can not be zero!",
                }),
                ...(!inputDetails?.gst && {
                  gstError: "GST number required",
                }),
              }));
            }
          } else {
            setFormError((prev: any) => ({
              ...prev,
              ...(inputDetails?.vatTaxRate !== 0 && {
                taxRateError:
                  "Tax Rate can not be zero when Tax Type is Taxable!",
              }),
            }));
          }
        } else {
          setFormError((prev: any) => ({
            ...prev,
            ...(!inputDetails?.hsnSacNo && {
              hsnError: "HSN/SAC number required",
            }),
            ...(inputDetails?.hsnSacNo === "0" && {
              hsnError: "HSN/SAC number can not be zero!",
            }),
            ...(inputDetails?.vatTaxType === "Exempt" && {
              taxRateError: "",
            }),
            ...(!inputDetails?.vatTaxRate &&
              inputDetails?.vatTaxType !== "Exempt" && {
                taxRateError: "Tax rate required",
              }),
            ...(inputDetails?.vatTaxType !== "Exempt" &&
              inputDetails.vatTaxRate === "0" && {
                taxRateError:
                  "Tax Rate can not be zero when Tax Type is Taxable!",
              }),
          }));
        }
      } else if (
        radioValue === "applicable" &&
        vatRadioValue === "not_applicable"
      ) {
        if (inputDetails?.hsnSacNo && inputDetails?.hsnSacNo !== "0") {
          if (taxRadioValue !== "taxable") {
            if (isEdit) {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 1,
                hsnSacNo: inputDetails?.hsnSacNo,
                hsnSacDetails: inputDetails?.hsnSacDetails,
                vatApplicable: 0,
                stockItemId: singleStockItemData[0]?.stock_item_id?.toString(),
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleUpdateStockItemData?.(finalData);
            } else {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 1,
                hsnSacNo: inputDetails?.hsnSacNo,
                hsnSacDetails: inputDetails?.hsnSacDetails,
                vatApplicable: 0,
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,

              };
              handleSubmitStockItemData?.(finalData);
            }
          } else if (
            taxRadioValue == "taxable" &&
            inputDetails?.gst !== "0" &&
            inputDetails?.gst
          ) {
            if (isEdit) {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 1,
                hsnSacNo: inputDetails?.hsnSacNo,
                hsnSacDetails: inputDetails?.hsnSacDetails,
                taxability: inputDetails?.taxability,
                gst: inputDetails?.gst,
                cess: inputDetails?.cess,
                vatApplicable: 0,
                stockItemId: singleStockItemData[0]?.stock_item_id?.toString(),
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleUpdateStockItemData?.(finalData);
            } else {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 1,
                hsnSacNo: inputDetails?.hsnSacNo,
                hsnSacDetails: inputDetails?.hsnSacDetails,
                taxability: inputDetails?.taxability,
                gst: inputDetails?.gst,
                cess: inputDetails?.cess,
                vatApplicable: 0,
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleSubmitStockItemData?.(finalData);
            }
          } else {
            setFormError((prev: any) => ({
              ...prev,
              ...(inputDetails?.gst === "0" && {
                gstError: "GST number can not be zero!",
              }),
              ...(!inputDetails?.gst && {
                gstError: "GST number required",
              }),
            }));
          }
        } else {
          setFormError((prev: any) => ({
            ...prev,
            ...(inputDetails?.hsnSacNo == "0" && {
              hsnError: "HSN/SAC number can not be zero",
            }),
            ...(!inputDetails?.hsnSacNo && {
              hsnError: "HSN/SAC number required",
            }),
          }));
        }
      } else if (
        vatRadioValue === "applicable" &&
        radioValue === "not_applicable"
      ) {
        if (
          vatRadioValue === "applicable" &&
          (inputDetails.vatTaxRate || inputDetails.vatTaxRate === 0)
        ) {
          if (
            inputDetails?.vatTaxRate === 0 &&
            vatTaxRadioValue === "exempted"
          ) {
            if (isEdit) {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 0,
                vatApplicable: 1,
                vatTaxType: inputDetails?.vatTaxType,
                vatTaxRate:
                  inputDetails?.vatTaxRate == 0
                    ? "0"
                    : inputDetails?.vatTaxRate,
                stockItemId: singleStockItemData[0]?.stock_item_id?.toString(),
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleUpdateStockItemData?.(finalData);
            } else {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 0,
                vatApplicable: 1,
                vatTaxType: inputDetails?.vatTaxType,
                vatTaxRate:
                  inputDetails?.vatTaxRate == 0
                    ? "0"
                    : inputDetails?.vatTaxRate,
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleSubmitStockItemData?.(finalData);
            }
          } else if (
            inputDetails?.vatTaxRate > 0 &&
            vatTaxRadioValue !== "exempted"
          ) {
            if (isEdit) {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 0,
                vatApplicable: 1,
                vatTaxType: inputDetails?.vatTaxType,
                vatTaxRate:
                  inputDetails?.vatTaxRate == 0
                    ? "0"
                    : inputDetails?.vatTaxRate,
                stockItemId: singleStockItemData[0]?.stock_item_id?.toString(),
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleUpdateStockItemData?.(finalData);
            } else {
              let finalData = {
                token,
                client_code,
                sku: inputDetails?.sku,
                stockGroupId: groupName?.value,
                stockItemName: inputDetails?.stockItemName.trim(),
                stockUnitId: stockItemUnits?.value,
                gstApplicable: 0,
                vatApplicable: 1,
                vatTaxType: inputDetails?.vatTaxType,
                vatTaxRate:
                  inputDetails?.vatTaxRate == 0
                    ? "0"
                    : inputDetails?.vatTaxRate,
                byProduct: newByProduct,
                coProduct: newCoProduct,
                scrap: newScrapProduct,
                rate: inputDetails?.rate ? inputDetails?.rate : null,
                uploads:allFileData,
                maximum: parseFloat(inputDetails?.maximum) ? parseFloat(inputDetails?.maximum) : 0,
                minimum: parseFloat(inputDetails?.minimum) ? parseFloat(inputDetails?.minimum) : 0,


              };
              handleSubmitStockItemData?.(finalData);
            }
          } else {
            setFormError((prev: any) => ({
              ...prev,
              ...(inputDetails?.vatTaxRate !== 0 && {
                taxRateError:
                  "Tax Rate can not be zero when Tax Type is Taxable!",
              }),
            }));
          }
        } else {
          setFormError((prev: any) => ({
            ...prev,
            ...(!inputDetails?.vatTaxRate && {
              taxRateError: "Tax Rate required",
            }),
          }));
        }
      }
    } else {
      setFormError((prev: any) => ({
        ...prev,
        ...(inputDetails?.sku === "0" && {
          skuError: "SKU number can not be zero!",
        }),
        ...(!inputDetails?.sku && { skuError: "SKU number required" }),
        ...((!inputDetails?.stockItemName ||
          inputDetails?.stockItemName.trim().length == 0) && {
          stockNameError: "Stock Name required",
        }),
        ...(!groupName?.value && {
          groupNameError: "Please choose Group Name",
        }),
        ...(!stockItemUnits?.value && {
          unitsError: "Please choose the Unit",
        }),
      }));
    }
  };

  const handleMaxLengthCheck = (e: any) => {
    if (e?.target.value.length > e?.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
      setInputDetails((prev: any) => ({
        ...prev,
        sku: e?.target.value,
      }));
    }
  };




  const handleFileChange = (file: any) => {
    // setFileData(file);
  
    const finalData = {
      token,
      fileData: file,
      containerType:1,
      


    };
  
      return dispatchUploadFilesAction(finalData);
  };
  
    const handleToggleUploadLogoModal = (e: any) => {
      e.preventDefault();
      setShowUploadLogoModal(!showUploadLogoModal);
    };
 

  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="SKU"
                  className={inputDetails?.sku ? "active" : ""}
                >
                  SKU
                  <span className="color-red">*</span>
                </label>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="number"
                    className={`form-control ${
                      !!formError.skuError ? "error-border" : null
                    }`}
                    name="sku"
                    value={inputDetails?.sku}
                    autoFocus
                    onChange={(e) => handleStockItemDetailsChange(e)}
                    maxLength={7}
                    onInput={handleMaxLengthCheck}
                    onWheel={(event) => event.currentTarget.blur()}
                  />
                  {uniqueSkuFetching && <RollingLoader />}
                </div>
                {!!formError?.skuError && (
                  <small className="text-danger">{formError?.skuError}</small>
                )}
                {!skuApiMessage?.includes("not") &&
                  !!inputDetails?.sku?.length &&
                  !!singleStockItemData &&
                  singleStockItemData[0]?.SKU.toString() !==
                    inputDetails.sku && (
                    <small className="text-danger">
                      SKU Number Already Exists!
                    </small>
                  )}
              </div>
              <span className="input-length">
                {returnInputFieldLength(inputDetails?.sku?.length, 7)}
              </span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="NAME">Stock Name
                <span className="color-red">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    !!formError.stockNameError ? "error-border" : null
                  }`}
                  name="stockName"
                  value={inputDetails?.stockItemName}
                  onChange={(e) => handleStockItemDetailsChange(e)}
                />
                {!!formError.stockNameError && (
                  <small className="text-danger">
                    {formError.stockNameError}
                  </small>
                )}
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="UNITS">Stock Units Measurment<span className="color-red">*</span>
                </label>
                <DropDown
                  options={options}
                  value={stockItemUnits}
                  handleChange={handleUnitOfMeasurementData}
                />
                <small className="text-danger">{formError.unitsError}</small>
              </div>
            </div>
          </form>
        </div>

        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="GROUP">Stock Group Name<span className="color-red">*</span></label>
                <Select<any, false>
                  classNamePrefix="react-select"
                  inputProps={{ autoComplete: "nope" }}
                  options={finalOptions}
                  className={`react-select`}
                  value={groupName}
                  onChange={handleGroupNameData}
                  isSearchable
                  components={{ Option }}
                />
                <small className="text-danger">
                  {formError.groupNameError}
                </small>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="row">
        <div className="col-md-2">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Rate">Rate</label>
                <input
                  type="number"
                  className={`form-control`}
                  name="rate"
                  value={inputDetails?.rate}
                  onChange={(e) => handleRateChange(e)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-2">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Minimum">Minimum Quantity</label>
                <input
                  type="number"
                  className={`form-control`}
                  name="minimum"
                  value={inputDetails?.minimum}
                  step="0.1"
                  onChange={(e) => handleMinMaxChange(e)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-2">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Maximum">Maximum Quantity
                  </label>
                {showAsterisk && <span className="color-red">*</span>}
                <input
                  type="number"
                  className={`form-control ${
                    !!formError.maximumError ? "error-border" : null
                  }`}
                  name="maximum"
                  step="0.1"
                  value={inputDetails?.maximum}
                  onChange={(e) => handleMinMaxChange(e)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
                {flag === true ? (
          <small className="text-danger"
          style={{ whiteSpace: "nowrap"}} >
          {formError?.maximumError}
        </small>
        ) : ( "")}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* by product  */}
      <h4 className="mt-3 mb-0">By Product</h4>

      {byProduct?.map((item: any, index: number) => {
        return (
          <div className="row" style={{ marginBottom: "-10px" }}>
            <div className="col-md-3">
              <form>
                <div className="form-group">
                  <div>
                    <label htmlFor="BYPRODUCT">{`By Product ${
                      byProduct?.length > 1
                        ? `${index < 10 ? "0" : ""}${index + 1}`
                        : ""
                    }`}</label>
                    <Select<any, false>
                      classNamePrefix="react-select"
                      inputProps={{ autoComplete: "nope" }}
                      options={finalStockItemDetailsOptions}
                      className={`react-select`}
                      value={
                        !!item?.byProductSingleData?.value
                          ? item?.byProductSingleData
                          : { label: "Select By-Product...", value: null }
                      }
                      onChange={(e: any) =>
                        handleStockItemData(e, "byProduct", index)
                      }
                      isSearchable
                      components={{ Option }}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="byProduct">% Of Cost Of Allocation</label>
              <input
                type="number"
                name="byProductPercent"
                value={item?.byProductPercent}
                disabled={!item?.byProductSingleData?.value}
                className="form-control"
                onChange={(e) => handleStockItemInputChange(e, index)}
                onWheel={(event) => event.currentTarget.blur()}
              />
            </div>

            {byProduct?.length > 1 ? (
              <div
                style={{ marginTop: "2rem", cursor: "pointer" }}
                onClick={() => handleDeleteRow("byProduct", index)}
              >
                <img src={RedDeleteIcon} alt="delete" />
              </div>
            ) : null}
          </div>
        );
      })}
      <div className="row mt-1 mb-3">
        <div className="col-12">
          <button
            className="btn btn-sm btn-outline pointer"
            onClick={() => handleAddMoreRow("byProduct")}
          >
            Add More
          </button>
        </div>
      </div>

      {/* co product  */}

      <h4 className="mt-3 mb-0">Co Product</h4>

      {coProduct?.map((item: any, index: number) => {
        return (
          <div className="row" style={{ marginBottom: "-10px" }}>
            <div className="col-md-3">
              <form>
                <div className="form-group mt-1">
                  <div>
                    <label htmlFor="COPRODUCT">
                      {" "}
                      {`Co Product ${
                        coProduct?.length > 1
                          ? `${index < 10 ? "0" : ""}${index + 1}`
                          : ""
                      }`}
                    </label>
                    <Select<any, false>
                      classNamePrefix="react-select"
                      inputProps={{ autoComplete: "nope" }}
                      options={finalStockItemDetailsOptions}
                      className={`react-select`}
                      value={
                        !!item?.coProductSingleData?.value
                          ? item?.coProductSingleData
                          : { label: "Select Co-Product...", value: null }
                      }
                      onChange={(e: any) =>
                        handleStockItemData(e, "coProduct", index)
                      }
                      isSearchable
                      components={{ Option }}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-3 form-group mt-1">
              <label
                htmlFor="SKU"
                className={inputDetails?.sku ? "active" : ""}
              >
                % Of Cost Of Allocation
              </label>
              <input
                type="number"
                name="coProductPercent"
                disabled={!item?.coProductSingleData?.value}
                value={item?.coProductPercent}
                className="form-control"
                onChange={(e) => handleStockItemInputChange(e, index)}
                onWheel={(event) => event.currentTarget.blur()}
              />
            </div>

            {coProduct?.length > 1 ? (
              <div
                style={{ marginTop: "2rem", cursor: "pointer" }}
                onClick={() => handleDeleteRow("coProduct", index)}
              >
                <img src={RedDeleteIcon} alt="delete" />
              </div>
            ) : null}
          </div>
        );
      })}

      <div className="row mt-1 mb-3">
        <div className="col-12">
          <button
            className="btn btn-sm btn-outline pointer"
            onClick={() => handleAddMoreRow("coProduct")}
          >
            Add More
          </button>
        </div>
      </div>
      {/* scrap  */}

      <h4 className="mt-3 mb-0">Scrap</h4>
      {scrapProduct?.map((item: any, index: number) => {
        return (
          <div className="row" style={{ marginBottom: "-10px" }}>
            <div className="col-md-3">
              <form>
                <div className="form-group mt-1">
                  <div>
                    <label htmlFor="SCRAP">{`scrap ${
                      scrapProduct?.length > 1
                        ? `${index < 10 ? "0" : ""}${index + 1}`
                        : ""
                    }`}</label>
                    <Select<any, false>
                      classNamePrefix="react-select"
                      inputProps={{ autoComplete: "nope" }}
                      options={finalStockItemDetailsOptions}
                      className={`react-select`}
                      value={
                        !!item?.scrapSingleData?.value
                          ? item?.scrapSingleData
                          : { label: "Select Scrap...", value: null }
                      }
                      onChange={(e: any) =>
                        handleStockItemData(e, "scrapProduct", index)
                      }
                      isSearchable
                      components={{ Option }}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-3 form-group mt-1">
              <label
                htmlFor="SKU"
                className={inputDetails?.sku ? "active" : ""}
              >
                % Of Cost Of Allocation
              </label>
              <input
                type="number"
                name="scrapProductPercent"
                value={item?.scrapProductPercent}
                disabled={!item?.scrapSingleData?.value}
                className="form-control"
                onChange={(e) => handleStockItemInputChange(e, index)}
                onWheel={(event) => event.currentTarget.blur()}
              />
            </div>

            {scrapProduct?.length > 1 ? (
              <div
                style={{ marginTop: "2rem", cursor: "pointer" }}
                onClick={() => handleDeleteRow("scrapProduct", index)}
              >
                <img src={RedDeleteIcon} alt="delete" />
              </div>
            ) : null}
          </div>
        );
      })}

      <div className="row mt-1 mb-3">
        <div className="col-12">
          <button
            className="btn btn-sm btn-outline"
            onClick={() => handleAddMoreRow("scrapProduct")}
          >
            Add More
          </button>
        </div>
      </div>

      <hr />
      <div className="row" style={{ marginTop: "25px" }}>
        <div className="col-md-6">
          <h4>GST Applicable:</h4>
          <div className="mt-3 mb-4">
            <RadioContainer
              optionsList={RADIO_OPTIONS}
              handleSetRadioValue={handleSetRadioValue}
              radioValue={radioValue}
            />
          </div>
        </div>
      </div>
      {/* {Gst Applicable} */}
      {radioValue == "applicable" && (
        <GstDetails
          taxRadioValue={taxRadioValue}
          setTaxRadioValue={setTaxRadioValue}
          formError={formError}
          setFormError={setFormError}
          setInputDetails={setInputDetails}
          inputDetails={inputDetails}
          clientMappedHSNData={clientMappedHSNData}
          hsnWarning={hsnWarning}
          setHsnWarning={setHsnWarning}
        />
      )}
      <div className="col-md-12">
        {taxRadioValue == "taxable" && radioValue == "applicable" && (
          <TaxDetails
            formError={formError}
            setFormError={setFormError}
            setInputDetails={setInputDetails}
            inputDetails={inputDetails}
          />
        )}
      </div>
      {(taxRadioValue == "taxable" || radioValue == "applicable") && <hr />}
      {/* {Vat Applicable} */}
      <div className="row" style={{ marginTop: "25px" }}>
        <div className="col-md-4">
          <h4>VAT Applicable:</h4>
          <div className="mt-3 mb-4">
            <RadioContainer
              optionsList={RADIO_OPTIONS}
              handleSetRadioValue={handleSetVatRadioValue}
              radioValue={vatRadioValue}
            />
          </div>
        </div>
      </div>

      {vatRadioValue == "applicable" && (
        <VatDetails
          formError={formError}
          setFormError={setFormError}
          setInputDetails={setInputDetails}
          inputDetails={inputDetails}
          setVatTaxRadioValue={setVatTaxRadioValue}
          vatTaxRadioValue={vatTaxRadioValue}
        />
      )}

      <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="btn btn-outline"
              onClick={(e:any) => {
                handleToggleUploadLogoModal(e);
              }}
            >
              + Upload File
            </button>
            <div className="pointer position-relative ml-4">
              {allFileData?.length ? (
                <span id="Popover1" 
                onClick={() => setShowImagePreview(true)}
                >
                  <PaperClipIcon />
                  <span className="badge count-badge" style={{ left: "11px" }}>
                    {allFileData?.length}
                  </span>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
     
      <div className="row mt-3">
        <div className="col-md-12 text-right">
          <button
            className="btn btn-link"
            onClick={() => {
              history?.push({
                pathname: `/client-settings/stock-manager/stock-items-list/${client_code}`,
                state: { client_code, company_name, searchData },
              });
            }}
          >
            Cancel
          </button>
          <button className="btn btn-primary" onClick={radioValue == "applicable"?handleCheckHsnWarning:handleSubmitForm} disabled={disable == true}>
            {isEdit ? "Update Stock Item" : "Submit"}
          </button>
        </div>
      </div>

      {showUploadLogoModal && (
        <MultiUploadWithApi
          modal={showUploadLogoModal}
          toggleModal={handleToggleUploadLogoModal}
          token={token}
          handleFileChange={handleFileChange}
          isDraggableModal
          acceptedFiles={"image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"}
          maxFileSize={2000000}
          supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
          multipleFileUploadData={stockFileUploadData}
          multipleFileUploadFetching={stockFileUploadFetching}
          allFileData={allFileData}
          setAllFileData={setAllFileData}
          multipleFileUploadSuccess={success}
          dispatchResetMultipleFileUploadSuccess={dispatchResetStockFileUploadSuccess}
          dispatchResetMultipleFileUploadError={dispatchResetStockFileUploadError}
        />
      )} 
        
          {showImagePreview&& 
          (<MultiFilePreviewModal show={showImagePreview} files={allFileData} onClose={() => setShowImagePreview(false)} 
          token={token}
          setAllFileData={setAllFileData}

          />)}

            {showHsnWarningConfirmModal && (
                   <ConfirmationModal
                     toggle={() => {
                       setShowHsnWarningConfirmModal(!showHsnWarningConfirmModal);
                     }}
                     isOpen={showHsnWarningConfirmModal}
                     title={"Warning"}
                     message={
                      hsnWarning?.hsnWarning?.includes('6') ? (
                        <>
                        <p style={{ fontSize:'14px', marginBottom:'8px',color:'#6e7491'}}>
                          Heads up! As per Notification No. 78/2020 – Central Tax, dated
                          15th October 2020 it's recommended to enter at least a 6-digit HSN
                          code for compliance.
                          </p>
                          <br />
                       Are you sure you want to proceed?
                        </>
                      ) : hsnWarning?.hsnWarning?.includes('4') ? (
                        <>
                        <p style={{ fontSize:'14px',marginBottom:'8px',color:'#6e7491'}}>
                          Heads up! As per Notification No. 78/2020 – Central Tax, dated
                          15th October 2020 it's recommended to enter at least a 4-digit HSN
                          code for compliance.
                          </p>
                          <br />
                          Are you sure you want to proceed?
                        </>
                      ) : (
                        <>
                          Heads up! As per GST guidelines, it's recommended to enter an
                          appropriate HSN code for compliance.
                        </>
                      )
                   
                     }
                     confirmButtonText={"Confirm"}
                     onPressConfirm={() => {
                      let finalData={
                        token,
                        clientCode:client_code,
                        invoiceType:"",
                        invoiceId:0,
                        warningSkippedAt:isEdit?"update_stock_item":"add_stock_item",
                        skuNumber:inputDetails?.sku,
                        stockItemId: isEdit?singleStockItemData[0]?.stock_item_id?.toString():0,

                      }
                      handleSubmitForm()
                      dispatchAddHsnCheckWarningAction(finalData)
                       setShowHsnWarningConfirmModal(!showHsnWarningConfirmModal);
                     }}
                   />
                 )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  stockFileUploadData:state.clientSettings.multipleFileUploadData,
  stockFileUploadFetching:state.clientSettings.multipleFileUploadFetching,
  success:state.clientSettings.multipleFileUploadSuccess,
  error :state.clientSettings.multipleFileUploadError,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  clientMappedHSNData: state.clientSettings.clientMappedHSNData,


 
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>
    dispatch(multipleUploadFilesAction(data)),
  dispatchResetStockFileUploadFetching:()=>dispatch(resetMultipleFileUploadFetching()),
  dispatchResetStockFileUploadData:()=>dispatch(resetMultipleFileUploadData()),
  dispatchResetStockFileUploadSuccess: () =>
    dispatch(resetMultipleFileUploadSuccess()),
  dispatchResetStockFileUploadError: () =>
    dispatch(resetMultipleFileUploadError()),
  dispatchGetTokenGenerateForDownloadAction: (data: GetGenerateSasTokenPayloadType) =>
    dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),

    dispatchGetHsnCheckAction: (data: GetHSNCheckPayloadType) => dispatch(getHsnCheckAction(data)),
    dispatchAddHsnCheckWarningAction:(data:AddHSNCheckWarningPayloadType)=>dispatch(addHsnCheckWarningAction(data))
  

});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockItemsFrom);
